import React, { useEffect } from "react";
import HomeContent from "../components/home/content";
import RootLayout from "./layout";
import { updateAllLayouts } from "@noriginmedia/norigin-spatial-navigation";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../redux/Slices/loading.slice";
import PageLayout from "../components/layout/PageLayout";
import { useShowcaseCacheWithConfig } from "../utils/hooks/useShowcaseCache";

const HomeScreen = () => {
  const dispatch = useDispatch();
  
  const { data: homeData, loading } = useShowcaseCacheWithConfig({
    cacheKey: "home",
    configKey: "home",
    versionTitle: "home",
  });

  // Handle loading state for sidebar
  useEffect(() => {
    if (loading) {
      dispatch(startLoading("در حال بارگذاری..."));
    } else {
      dispatch(stopLoading());
      updateAllLayouts();
    }
  }, [loading, dispatch]);

  return (
    <RootLayout>
      <PageLayout loading={loading} skeletonType="home">
        {homeData && <HomeContent showCaseData={homeData} />}
      </PageLayout>
    </RootLayout>
  );
};

export default HomeScreen;

